import styles from "./index.module.scss";
import { useTranslations } from "next-intl";
import React, { Dispatch } from "react";

export default function DepositHeader({
  onClick,
  type,
}: {
  onClick: Dispatch<"in" | "out">;
  type: string;
}) {
  const t = useTranslations("DepositModal");

  return (
    <div className={styles.tabsContainer}>
      <button
        className={`${styles.tabItem} ${type === "in" ? styles.active : ""}`}
        onClick={() => {
          onClick("in");
        }}
      >
        <span className={styles.tabText}>{t("tab_deposit")}</span>
      </button>
      <button
        className={`${styles.tabItem} ${type === "out" ? styles.active : ""}`}
        onClick={() => {
          onClick("out");
        }}
      >
        <span className={styles.tabText}>{t("tab_withdraw")}</span>
      </button>
    </div>
  );
}
